/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { assign } from 'lodash'



const basePath = '/membership/users'

const usersEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchUsers: builder.query<any, {page: number, type: string}>({
    query: ({page, type}) => ({
      url: `${basePath}?page=${page}&size=10&userType=${type}`,
      method: 'get',
    }),
    providesTags: ['users'],
  }),

  createUser: builder.mutation<any, any>({ 
    query: (body) => ({
      url: `${basePath}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  updateUser: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  deleteUser: builder.mutation<any, any>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['users'],
  }),

  addMembership: builder.mutation<any, any>({
    query: (body) => ({
      url: `/memberships`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  searchAUser: builder.query<any, string>({
    query: (query) => ({
      url: `${basePath}?${query}`,
      method: 'get',
    }),
  }),

  addRental: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `/${userId}/rentals`,
      method: 'post',   
      body,
    }),
    invalidatesTags: ['users'],
  }),

  assignMembershipToUser: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `${basePath}/${userId}/membership`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  editAssignedUserMembership: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `${basePath}/${userId}/membership`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  deleteAssignedUserMembership: builder.mutation<any, any>({
    query: ({ userId, membershipId }) => ({
      url: `${basePath}/${userId}/membership/${membershipId}`,
      method: 'delete',
    }),
    invalidatesTags: ['users'],
  }),

  assignRentalToUser: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `${basePath}/${userId}/rentals`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  deleteAssignedRental: builder.mutation<any, any>({
    query: ({ userId, rentalId }) => ({
      url: `${basePath}/${userId}/rentals/${rentalId}`,
      method: 'delete',
    }),
    invalidatesTags: ['users'],
  }),

  hasReturnedRental: builder.mutation<any, any>({
    query: ({ userId, rentalId, body }) => ({
      url: `${basePath}/${userId}/rentals/${rentalId}`,
      method: 'post',
      body: body,
    }),
    invalidatesTags: ['users'],
  }),

  getAssignedRentalDetails: builder.query<any, { userId: string | undefined; rentalId: string }>({
    query: ({ userId, rentalId }) => ({
      url: `${basePath}/${userId}/rentals/${rentalId}`,
      method: 'get',
    }),
  }),

  getUserTransactions: builder.query<any, string>({
    query: (userId) => ({
      url: `${basePath}/${userId}/transactions`,
      method: 'get',
    }),
  }),

  fetchUserPayments: builder.query<any, { userId: string | undefined; page: number; size: number }>({
    query: ({ userId, page, size }) => ({
      url: `${basePath}/${userId}/payments?page=${page}&size=${size}`,
      method: 'get',
    }),
  }),

  assignOfficeToUser: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `${basePath}/${userId}/office`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  completeUserPayment: builder.mutation<any, any>({
    query: ({ paymentId, body }) => ({
      url: `${basePath}/${paymentId}/finish-payments`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  cancelUserRental: builder.mutation<any, any>({
    query: ({ userId, rentalId, body }) => ({
      url: `${basePath}/${userId}/cancel-rentals/${rentalId}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['users'],
  }),

  editMembershipImage: builder.mutation<any, any>({
    query: ({ userId, body }) => ({
      url: `${basePath}/${userId}/image`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['users'],
  }),

})

export default usersEndpoints



